const switcher = () => {
    const switchButtons = document.querySelectorAll('#price-switch a');
    const prices = document.querySelectorAll('h2.price');
    const switchMonth = document.getElementById('price-switch-monthly');
    const switchYear = document.getElementById('price-switch-yearly');
    const switchToggle = document.getElementById('price-switch-toggle');
    switchButtons.forEach(e => {
        e.addEventListener('click', event => {
            let action = e.dataset['switchto']
            if (action == 'monthly') {
                switchMonth.classList.add('active')
                switchYear.classList.remove('active')
                switchToggle.classList.add('fa-toggle-off')
                switchToggle.classList.remove('fa-toggle-on')
            } else if (action == 'yearly') {
                switchMonth.classList.remove('active')
                switchYear.classList.add('active')
                switchToggle.classList.add('fa-toggle-off')
                switchToggle.classList.remove('fa-toggle-on')
            }  else if (action == 'toggle') {
                switchMonth.classList.toggle('active')
                switchYear.classList.toggle('active')
                switchToggle.classList.toggle('fa-toggle-off')
                switchToggle.classList.toggle('fa-toggle-on')
                if (switchToggle.classList.contains('fa-toggle-on')) {
                    action = 'monthly'
                } else {
                    action = 'yearly'
                }
            }
            prices.forEach(e => {
                e.innerHTML = e.dataset[action]
            })
        })
    })
};

export default switcher;
